<template>
  <div class="restore-password-page  flex-grow-1">
    <b-container class="d-flex h-100">
      <b-form class="m-auto auth-form" @submit.prevent="onReset">
        <p v-if="pageMessage" class="text-center">{{ pageMessage }}</p>

        <h3 align="center" class="mb-3">Восстановление пароля</h3>
        <p class="text-center">
          Введите E-mail, который использовали при регистрации
        </p>

        <b-overlay
          :show="loader"
          rounded="sm"
          variant="white"
          opacity=".35"
          blur="4px"
          class=""
        >
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="$v.form.email.$model"
              placeholder="E-mail"
              :state="validateState('email')"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.form.email.email"
              >Некорректный E-mail</b-form-invalid-feedback
            >
            <b-form-invalid-feedback v-if="!$v.form.email.required"
              >Необходимо ввести E-mail</b-form-invalid-feedback
            >
          </b-form-group>

          <b-button type="submit" variant="warning" size="lg" block>
            Восстановить
          </b-button>
          <p class="text-center pt-4">
            <router-link to="/login" class="text-secondary">
              На страницу входа
            </router-link>
          </p>
        </b-overlay>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import msg from '@/utils/messages';

export default {
  data() {
    return {
      loader: false,
      form: {
        email: ''
      },
      pageMessage: false
    };
  },
  validations: {
    form: {
      email: { email, required }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onReset() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$v.$touch();
        return;
      }

      this.loader = true;

      try {
        const response = await this.$store.dispatch(
          'restorePassword',
          this.form
        );
        if (response) {
          this.pageMessage = msg.CHECK_YOUR_EMAIL;
          this.form.email = '';
          this.$v.$reset();
        }
        this.loader = false;
      } catch (e) {
        this.loader = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.restore-password-page {
  background-color: #f5f5f5;
}
</style>